module.exports = __webpack_public_path__ + "static/img/no-equip.05668813.png";